import axios from 'axios';

const API_URL = 'https://construction-backend-531984037368.us-central1.run.app/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

export const projectService = {
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  getAll: () => api.get('/projects'),
  getOne: (id) => api.get(`/projects/${id}`),
  update: (id, data) => api.put(`/projects/${id}`, data),
};

export const scopeService = {
  create: (data) => api.post('/scopes', data),
  getByProject: (project_id) => api.get(`/scopes/project/${project_id}`),
  getOpen: () => api.get('/scopes/open'),
};

export const proposalService = {
  create: (data) => api.post('/proposals', data),
  getByScope: (scope_id) => api.get(`/proposals/scope/${scope_id}`),
  getMy: () => api.get('/proposals/my'),
  select: (id) => api.put(`/proposals/${id}/select`),
};

export const contractService = {
  create: (data) => api.post('/contracts', data),
  getAll: () => api.get('/contracts'),
  sign: (id) => api.put(`/contracts/${id}/sign`),
};

export const milestoneService = {
  create: (data) => api.post('/milestones', data),
  getByContract: (contract_id) => api.get(`/milestones/contract/${contract_id}`),
  updateStatus: (id, status) => api.put(`/milestones/${id}/status`, { status }),
};

export const invoiceService = {
  submit: (data) => api.post('/invoices', data),
  getAll: () => api.get('/invoices'),
  approve: (id) => api.put(`/invoices/${id}/approve`),
  markPaid: (id, data) => api.put(`/invoices/${id}/paid`, data),
};

export default api;
